<template>
    <div>
        <span v-if="customerGroupId == 2" class="spn-panel">پنل همکاری</span>
        <router-link class="btn btn-default btn-omdeh" to="/descriptionBulkPurchases" title="توضیحات خرید عمده">خرید عمده</router-link>

        <div class="cart dropdown" v-if="cart != null">
            <a @click="isLoginedUeser" title="سبد خرید" class="btn dropdown-toggle" data-toggle="dropdown" id="navbarDropdownMenuLink1">
                <i class="now-ui-icons shopping_cart-simple"></i>
                سبد خرید
                <span class="count-Item"> {{  cart.CartInfo.CartDetailsCount }} </span>
            </a>
            <ul class="dropdown-menu" aria-labelledby="navbarDropdownMenuLink1">
                <div class="basket-header">
                    <div class="basket-total">
                        <span>جمع مبلغ خرید:</span>
                        <span> {{ cart.CartInfo.AmountPayable | formatNumber}}</span>
                        <span> ریال</span>
                    </div>
                    <router-link to="/cart" tag="a" class="basket-link" title="مشاهده سبد خرید">
                        <span>مشاهده سبد خرید</span>
                        <div class="basket-arrow"></div>
                    </router-link>
                </div>
                <ul class="basket-list">
                    <li v-for="(cartDetail ,  index) in cart.CartInfo.CartDetails">
                        <a class="basket-item">
                            <button @click="removeItem(cartDetail.ProductSaleParamId)" class="basket-item-remove"></button>
                            <div @click="redirectToProduct(cartDetail.ProductId , cartDetail.ProductName.replace(/\s+/g, '-'))" class="basket-item-content cursor-pointer">
                                <div class="basket-item-image">
                                    <img alt="" :src="cartDetail.ProductPicPath" @error="imageLoadOnError">
                                </div>
                                <div class="basket-item-details">
                                    <div class="basket-item-title">
                                        {{ cartDetail.ProductName }}
                                    </div>
                                    <div class="basket-item-params">
                                        <div class="basket-item-props">
                                            <span> {{ cartDetail.Quantity }} {{  cartDetail.Unit }}</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </a>
                    </li>
                </ul>
                <router-link v-if="isUserLogined" to="/chooseAddress" title="ثبت سفارش و ارسال" class="basket-submit">ثبت سفارش و ارسال</router-link>
                <router-link v-else to="/login" title="ورود و ثبت سفارش" class="basket-submit">ورود و ثبت سفارش</router-link>

            </ul>
        </div>


        <div class="cart dropdown" v-else="">
            <router-link to="/cart" title="سبد خرید" class="btn">
                <i class="now-ui-icons shopping_cart-simple"></i>
                سبد خرید
            </router-link>
        </div>



    </div>
</template>

<script>
    import { getCart } from "../../../module/cart";
    import { setCart } from "../../../module/cart";
    export default {
        data() {
            return {
                isUserLogined: false,
            }
        },

        computed: {
            cart: function () {
                return this.$store.getters.readCart;
            },
            customerGroupId: function () {
                return this.$store.getters.readCustomerGroupId;
            },
        },
        methods: {
            removeItem(productSaleParamId) {
                setCart(this, productSaleParamId, 'RemoveItem', '');
            },
            isLoginedUeser() {
                this.isUserLogined = IsNullOrEmptyString(localStorage.getItem('accessToken')) ? false : true;
            },
            imageLoadOnError(event) {
                event.target.src = "/assets/img/no-image-available.png";
            },
            redirectToProduct(productId, productName ) {
                this.$router.push({ name: 'product', params: { productId: productId, productName: productName } })
            }
        },
        beforeMount() {
            getCart(this, '');
        }

    }
</script>

<style scoped>
    .btn-omdeh {
        background-color: #dcbd91;
        padding: 4px 15px 6px 15px;
        margin-left: 10px;
        margin-right: 10px;
        color: #333 !important;
        padding: 1px 12px 5px 12px;
        border-radius: 7px;
        font-size: 14px;
        line-height: 1.9
    }

    .spn-panel {
        background-color: #dcbd91;
        display: inline-block;
        margin-top: 5px;
        color: #333;
        padding: 1px 12px 5px 12px;
        border-radius: 7px;
        font-size: 14px;
        line-height: 1.9;
    }
    .cursor-pointer{
        cursor:pointer;
    }
</style>